// Variables inserted as chips inside the contract editor. Items in the
// "Signature" group carry `isSignature` for the blue chip styling. The single
// REQUIRED signature is `SIGNATURE_VARIABLE_KEY` (`{SIG_client}`) — Save
// validates its presence and view-mode renders it as a signature line. The
// companion `{SIG_date}` (`SIGNATURE_DATE_VARIABLE_KEY`) is optional: the date
// the client signs, which the backend expands into a BoldSign date field at
// PDF-render time (see ContractAPI constants.BOLDSIGN_TAG_MAP).

export const CONTRACT_VARIABLES = [
  {
    group: "Job Info",
    items: [
      { key: "Client_Name", label: "Client Name" },
      { key: "Client_Email", label: "Client Email" },
      { key: "Property_Address", label: "Property Address" },
      { key: "Total_Fee", label: "Total Fee" },
      { key: "Inspection_Date", label: "Inspection Date & Time" },
      { key: "Service_Type", label: "Services" },
      { key: "Agent_Name", label: "Agent Name" },
    ],
  },
  {
    group: "Signature",
    items: [
      { key: "SIG_client", label: "Client Signature", isSignature: true },
      { key: "SIG_date", label: "Client Sign Date", isSignature: true },
    ],
  },
];

// Old tokens still present in existing templates, mapped to the token that
// replaced them. Loading a template swaps these for the canonical chip, so
// saving it drops the old token for good.
export const DEPRECATED_VARIABLE_ALIASES = {
  Job_Address: "Property_Address",
};

export const SIGNATURE_VARIABLE_KEY = "SIG_client";
export const SIGNATURE_DATE_VARIABLE_KEY = "SIG_date";
